/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Home_Offerhover_Morefeatures2Inputs */

const id_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} lainnya`)
};

const ms_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} lagi`)
};

const da_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} mere`)
};

const de_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} mehr`)
};

const en_us2_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} more`)
};

const es_es2_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} más`)
};

const es_mx2_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} más`)
};

const fil_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} pa`)
};

const fr_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} de plus`)
};

const it_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} altro`)
};

const hu_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} további`)
};

const nl_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} meer`)
};

const no_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} til`)
};

const pl_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} więcej`)
};

const pt_br2_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count} mais`)
};

const pt_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} mais`)
};

const ro_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} mai multe`)
};

const fi_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} lisää`)
};

const sv_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} fler`)
};

const vi_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} tính năng khác`)
};

const tr_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} daha`)
};

const cs_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} dalších`)
};

const bg_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} още`)
};

const ru_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`и ещё +${i?.count}`)
};

const uk_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} ще`)
};

const ar_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} المزيد`)
};

const hi_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} और`)
};

const th_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} เพิ่มเติม`)
};

const ja_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} 件`)
};

const zh_cn2_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} 个更多`)
};

const zh_hant1_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count} 個更多`)
};

const ko_home_offerhover_morefeatures2 = /** @type {(inputs: Home_Offerhover_Morefeatures2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (` +${i?.count}개 더`)
};

/**
* | output |
* | --- |
* | "+{count} more" |
*
* @param {Home_Offerhover_Morefeatures2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_offerhover_morefeatures2 = /** @type {((inputs: Home_Offerhover_Morefeatures2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Offerhover_Morefeatures2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_offerhover_morefeatures2(inputs)
	if (locale === "ms") return ms_home_offerhover_morefeatures2(inputs)
	if (locale === "da") return da_home_offerhover_morefeatures2(inputs)
	if (locale === "de") return de_home_offerhover_morefeatures2(inputs)
	if (locale === "en-US") return en_us2_home_offerhover_morefeatures2(inputs)
	if (locale === "es-ES") return es_es2_home_offerhover_morefeatures2(inputs)
	if (locale === "es-MX") return es_mx2_home_offerhover_morefeatures2(inputs)
	if (locale === "fil") return fil_home_offerhover_morefeatures2(inputs)
	if (locale === "fr") return fr_home_offerhover_morefeatures2(inputs)
	if (locale === "it") return it_home_offerhover_morefeatures2(inputs)
	if (locale === "hu") return hu_home_offerhover_morefeatures2(inputs)
	if (locale === "nl") return nl_home_offerhover_morefeatures2(inputs)
	if (locale === "no") return no_home_offerhover_morefeatures2(inputs)
	if (locale === "pl") return pl_home_offerhover_morefeatures2(inputs)
	if (locale === "pt-BR") return pt_br2_home_offerhover_morefeatures2(inputs)
	if (locale === "pt") return pt_home_offerhover_morefeatures2(inputs)
	if (locale === "ro") return ro_home_offerhover_morefeatures2(inputs)
	if (locale === "fi") return fi_home_offerhover_morefeatures2(inputs)
	if (locale === "sv") return sv_home_offerhover_morefeatures2(inputs)
	if (locale === "vi") return vi_home_offerhover_morefeatures2(inputs)
	if (locale === "tr") return tr_home_offerhover_morefeatures2(inputs)
	if (locale === "cs") return cs_home_offerhover_morefeatures2(inputs)
	if (locale === "bg") return bg_home_offerhover_morefeatures2(inputs)
	if (locale === "ru") return ru_home_offerhover_morefeatures2(inputs)
	if (locale === "uk") return uk_home_offerhover_morefeatures2(inputs)
	if (locale === "ar") return ar_home_offerhover_morefeatures2(inputs)
	if (locale === "hi") return hi_home_offerhover_morefeatures2(inputs)
	if (locale === "th") return th_home_offerhover_morefeatures2(inputs)
	if (locale === "ja") return ja_home_offerhover_morefeatures2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_offerhover_morefeatures2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_offerhover_morefeatures2(inputs)
	return ko_home_offerhover_morefeatures2(inputs)
});
export { home_offerhover_morefeatures2 as "home.offerHover.moreFeatures" }